module.exports = __webpack_public_path__ + "img/banner_sezamo.3e26424f.png";